import React, { useState, Fragment } from "react";
import CardLayout from "../../../../common/cardLayout/CardLayout";
import moment from "moment";
import { Line, Bar } from "react-chartjs-2";
import { ReactComponent as BarChartIcon } from "../../../../../assets/icons/barChart.svg";
import { ReactComponent as RefreshIcon } from "../../../../../assets/icons/refresh-circular.svg";
import { ReactComponent as DownloadIcon } from "../../../../../assets/icons/download.svg";

const DBTContent = (props) => {
  const chartData = props.dbtData;
  const [showLineChart, setShowLineChart] = useState(true);

  const downloadImage = () => {
    if (showLineChart) {
      var a = document.createElement("a");
      a.href = LineChart.toBase64Image;
      a.download = "LineChart.png";
      a.click();
    } else {
      var a = document.createElement("a");
      a.href = BarChart.toBase64Image;
      a.download = "BarChart.png";
      a.click();
    }
  };

  const labels = chartData?.map((item) => {
    return moment(item?.created_at).format("MMM-DD");
  });
  const angerData = chartData?.map((item) => {
    return item?.anger_level;
  });
  const fearData = chartData?.map((item) => {
    return item?.fear_level;
  });
  const shameData = chartData?.map((item) => {
    return item?.shame_level;
  });
  const sadData = chartData?.map((item) => {
    return item?.sad_level;
  });
  const suicidalData = chartData?.map((item) => {
    return item?.suicidal_ideation_level;
  });
  const selfHarmData = chartData?.map((item) => {
    return item?.self_harm_level;
  });
  const tbOneData = chartData?.map((item) => {
    return item?.target_behavior_1_level;
  });
  const tbTwoData = chartData?.map((item) => {
    return item?.target_behavior_2_level;
  });
  const data = {
    labels: labels,
    datasets: [
      {
        label: "Anger",
        backgroundColor: "#00008B",
        borderColor: "#00008B",
        data: angerData,
      },
      {
        label: "Fear",
        backgroundColor: "#6495ED",
        borderColor: "#6495ED",
        data: fearData,
      },
      {
        label: "Shame",
        backgroundColor: "#FF7F50",
        borderColor: "#FF7F50",
        data: shameData,
      },
      {
        label: "Sad",
        backgroundColor: "#483D8B",
        borderColor: "#483D8B",
        data: sadData,
      },
      {
        label: "Sucidal",
        backgroundColor: "#FFA07A",
        borderColor: "#FFA07A",
        data: suicidalData,
      },
      {
        label: "Self Harm",
        backgroundColor: "#00FFFF",
        borderColor: "#00FFFF",
        data: selfHarmData,
      },
      {
        label: "TBOne",
        backgroundColor: "#000000",
        borderColor: "#000000",
        data: tbOneData,
      },
      {
        label: "TBTwo",
        backgroundColor: "#A9A9A9",
        borderColor: "#A9A9A9",
        data: tbTwoData,
      },
    ],
  };
  const LineChart = () => {
    return (
      <div className="col-sm-7 col-md-7 col-lg-7">
        <Line
          data={data}
          options={{
            legend: {
              labels: {
                usePointStyle: true,
                boxWidth: 6,
              },
            },
            scales: {
              x: {
                gridLines: {
                  display: false,
                },
              },
              y: {
                beginAtZero: true,
                max: 5,
                title: {
                  display: true,
                  text: "Assessment Risk Level",
                  color: "gray",
                  font: {
                    family: "DM Sans",
                    size: 20,
                    style: "normal",
                    lineHeight: 1.2,
                  },
                  padding: { top: 30, left: 0, right: 0, bottom: 0 },
                },
                type: "linear",
                ticks: {
                  stepSize: 1,
                },
                gridLines: {
                  display: true,
                },
              },
            },
          }}
        />
      </div>
    );
  };
  const BarChart = () => {
    return (
      <div className="col-sm-7 col-md-7 col-lg-7">
        <Bar
          data={data}
          options={{
            legend: {
              labels: {
                usePointStyle: true,
                boxWidth: 6,
              },
            },
            scales: {
              x: {
                gridLines: {
                  display: false,
                },
              },
              y: {
                beginAtZero: true,
                max: 5,
                title: {
                  display: true,
                  text: "Assessment Risk Level",
                  color: "gray",
                  font: {
                    family: "DM Sans",
                    size: 20,
                    style: "normal",
                    lineHeight: 1.2,
                  },
                  padding: { top: 30, left: 0, right: 0, bottom: 0 },
                },
                type: "linear",
                ticks: {
                  stepSize: 1,
                },
                gridLines: {
                  display: true,
                },
              },
            },
          }}
        />
      </div>
    );
  };
  return (
    <Fragment>
      <CardLayout
        className="col-sm-12 col-md-12 col-lg-12"
        style={{
          border: "8px solid transparent",
          boxSizing: "border-box",
          backgroundClip: "padding-box",
        }}
      >
        <div className="row col-sm-12 col-md-12 col-lg-12">
          <h4 style={{ textAlign: "left" }}>{props.name}</h4>
        </div>
        <div
          className="row col-sm-10 col-md-10 col-lg-10"
          style={{ margin: "0px", padding: "0px" }}
        >
          <div className="d-flex justify-content-end">
            <button
              class="btn"
              title="Show bar chart"
              onClick={() => setShowLineChart(false)}
            >
              <i>
                {" "}
                <BarChartIcon />
              </i>
            </button>
            <button
              class="btn"
              title="Revert to Line chart"
              onClick={() => setShowLineChart(true)}
            >
              <i>
                {" "}
                <RefreshIcon />
              </i>
            </button>
            <button class="btn" title="Save as Image" onClick={downloadImage}>
              <i>
                {" "}
                <DownloadIcon />
              </i>
            </button>
          </div>
        </div>
        {showLineChart ? <LineChart /> : <BarChart />}
      </CardLayout>
    </Fragment>
  );
};
export default DBTContent;
